// @flow
import React, { Fragment, useEffect, useState } from "react";
import parse from "html-react-parser";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";

import "./EditableContent.css";

import ICPCJoditEditor from "components/ICPCJoditEditor";

const HTMLDecoderEncoder = require("html-encoder-decoder");

const defaultContent =
  "Left menu offers various topics with frequently asked questions (FAQs). It is possible to ask your own question, although try to find an answer in the list of topics first. Status of your question can be tracked and once an answer is provided, both the question and answer might be(or not) published in the list.";
const defaultTitle = "ICPC Help Center";

function EditableContent(props: {
  title: string,
  content: string,
  isAdmin: Boolean,
  handleSave: (string, string) => void,
  handleSaveNew?: (string) => void,
  onContentClick?: (string, string) => void,
}) {
  const [edit, setEdit] = useState(false);
  const [add, setAdd] = useState(false);
  const [currentContent, setCurrentContent] = useState(props.content);
  const [currentTitle, setCurrentTitle] = useState(props.title);
  const [currentNewTitle, setCurrentNewTitle] = useState("");
  const { isAdmin, handleSave, handleSaveNew } = props;

  //if the content in props change then change the state too
  useEffect(() => {
    setCurrentContent(props.content);
  }, [props.content]);

  //if the title  in props change then change the title too
  useEffect(() => {
    setCurrentTitle(props.title);
  }, [props.title]);

  const titleError: boolean = !currentTitle;
  const newTitleError: boolean = !currentNewTitle;
  return (
    <React.Fragment>
      <div>
        {edit ? (
          <Fragment>
            <TextField
              id="title"
              label="Title"
              variant="outlined"
              value={currentTitle}
              error={titleError}
              onChange={(e) => {
                setCurrentTitle(e.target.value);
              }}
              placeholder={defaultTitle}
              required={true}
              helperText={titleError && "Title is required."}
              style={{ marginBottom: "2px" }}
            />
            <Button
              variant="contained"
              color="primary"
              disabled={!(currentTitle && currentContent)}
              onClick={() => {
                handleSave(
                  currentTitle,
                  HTMLDecoderEncoder.encode(currentContent)
                );
                setEdit(false);
              }}
              style={{ float: "right", marginRight: "12px", marginTop: "4px" }}
            >
              SAVE
            </Button>
          </Fragment>
        ) : add ? (
          <Fragment>
            <TextField
              id="newTitle"
              label="New Title"
              variant="outlined"
              value={currentNewTitle}
              error={newTitleError}
              onChange={(e) => {
                setCurrentNewTitle(e.target.value);
              }}
              placeholder="New Title"
              required={true}
              helperText={newTitleError && "Title is required."}
              style={{ marginBottom: "2px" }}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                if (handleSaveNew) handleSaveNew(currentNewTitle);
                setAdd(false);
              }}
              style={{ float: "right", marginRight: "12px", marginTop: "4px" }}
            >
              ADD
            </Button>
          </Fragment>
        ) : (
          <Fragment>
            <Typography
              variant="h4"
              style={{ marginBottom: 12, display: "inline-block" }}
            >
              {currentTitle || defaultTitle}
            </Typography>
            {isAdmin && (
              <span>
                {handleSaveNew && (
                  <Button
                    onClick={() => setAdd(true)}
                    variant="contained"
                    color="primary"
                    style={{
                      float: "right",
                      marginRight: "12px",
                      marginTop: "4px",
                    }}
                  >
                    ADD NEW TOPIC
                  </Button>
                )}
                <Button
                  onClick={() => setEdit(true)}
                  variant="contained"
                  color="primary"
                  style={{
                    float: "right",
                    marginRight: "12px",
                    marginTop: "4px",
                  }}
                >
                  EDIT
                </Button>
              </span>
            )}
          </Fragment>
        )}
      </div>
      <div
        style={{
          lineHeight: "145%",
          color: "#2b2b2b",
          paddingLeft: 0,
          paddingRight: 0,
        }}
        className="ql-editor content-image"
      >
        {!add &&
          (currentContent ? (
            edit ? (
              <ICPCJoditEditor
                data={HTMLDecoderEncoder.decode(currentContent)}
                onChange={(value) => setCurrentContent(value)}
              />
            ) : (
              parse(HTMLDecoderEncoder.decode(currentContent))
            )
          ) : (
            <Typography>{defaultContent}</Typography>
          ))}
      </div>
    </React.Fragment>
  );
}

export default EditableContent;
